module.exports = __webpack_public_path__ + "img/20t.prt.3f554919.jpg";